import React, { useEffect } from 'react';

function EventPage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="event-page">
      {/* Top Navigation Bar */}
      <div className="event-top-bar">
        <div className="event-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="event-title-text">Event</div>
        <div className="event-spacer"></div>
      </div>

      {/* Content Area */}
      <div className="certificate-content">
        <div className="certificate-image-container">
          <img 
            src="/event/event.jpg" 
            alt="Event" 
            className="certificate-image"
            onError={(e) => {
              // Fallback if image doesn't exist
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="certificate-placeholder" style={{ display: 'none' }}>
            <i className="bi bi-calendar-check certificate-placeholder-icon"></i>
            <p className="certificate-placeholder-text">Event Image</p>
            <p className="certificate-placeholder-hint">Place your event image at /public/event/event.jpg</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventPage;

